export const SEARCH_DRIVER = 'SEARCH_DRIVER'
export const SEARCH_DRIVER_SUCCESS = 'SEARCH_DRIVER_SUCCESS'
export const SEARCH_DRIVER_FAIL = 'SEARCH_DRIVER_FAIL'

export const EDIT_DRIVER = 'EDIT_DRIVER'
export const EDIT_DRIVER_SUCCESS = 'EDIT_DRIVER_SUCCESS'
export const EDIT_DRIVER_FAIL = 'EDIT_DRIVER_FAIL'

export const DOWNLOAD_PDF = 'DOWNLOAD_PDF'
export const DOWNLOAD_PDF_SUCCESS = 'DOWNLOAD_PDF_SUCCESS'
export const DOWNLOAD_PDF_FAIL = 'DOWNLOAD_PDF_FAIL'

export const DRIVER_LOGIN = 'DRIVER_LOGIN'
export const DRIVER_LOGIN_SUCCESS = 'DRIVER_LOGIN_SUCCESS'
export const DRIVER_LOGIN_FAIL = 'DRIVER_LOGIN_FAIL'

export const SEND_EMAIL = 'SEND_EMAIL'
export const SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS'
export const SEND_EMAIL_FAIL = 'SEND_EMAIL_FAIL'
